import "../helpers/jquery.stackmenu.js"

// Get the navigation menu
let $stack = $('[data-stack-menu]')
$stack.stackMenu()
// Avoids the 'flash' as CSS loads.
$stack.removeAttr('style')


//

/**
*
* Close / Open the mobile nav
*
*/
function toggleMobileNav() {
    $('[data-mobile-menu]').toggleClass('is--active')
    $('[data-hamburger] .close-button').toggleClass('hidden')
    $('[data-mobile-menu-alt]').toggleClass('is--active')
    $('[data-mobile-menu-child]').scrollTop(0);
    $stack.toggleClass('is--active')
    $('body')
        .toggleClass('overflow-hidden')
        .toggleClass('mobile-nav-open')
}

/**
*
* Toggle the hamburger
*
*/
let $hamburger = $('[data-hamburger]')
$hamburger.on('click', function(e){
    $(this).toggleClass('is-active')
    e.preventDefault()
    toggleMobileNav()
})

/**
*
* Toggle the child menus on mobile
*
*/
let $childToggle = $('[data-mobile-menu-child-toggle]')
$childToggle.on('click', function(e){
    e.preventDefault()
    let id = $(this).data('mobile-menu-child-toggle')
    $('[data-mobile-menu-child]').scrollTop(0);
    $('[data-mobile-menu-child]').removeClass('is--active')
    $('[data-mobile-menu-child="'+id+'"]').addClass('is--active')
})
/**
*
* Toggle the child menus on mobile
*
*/
let $childToggleBack = $('[data-mobile-menu-child-back]')
$childToggleBack.on('click', function(e){
    e.preventDefault()
    $('[data-mobile-menu-child]').removeClass('is--active')
})

/**
*
* Close the hamburger
*
*/
let $menuClose = $('[data-hamburger-close]')
$menuClose.on('click', function(e){
    e.preventDefault()
    toggleMobileNav()
})

/**
*
* Allow clicking outside of the mobile nav
*
*/
$('body').on('click', function(e) {

    if ( $(e.target).closest('.mobile-menu').length == 0 &&
         $(e.target).closest('[data-hamburger]').length == 0 &&
         $('body').hasClass('mobile-nav-open') ) {
            $hamburger.toggleClass('is-active')
            toggleMobileNav()
    }

})
